// extracted by mini-css-extract-plugin
module.exports = {"dianpin":"teaching-detail_dianpin__3DmAN"};